// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import ElementUI from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css'
import "../theme/index.css";

import router from "./router";
import store from "./store";
import App from "./App";
import axios from "axios";
import WS from "./lib/websocket";

axios.defaults.withCredentials = true;
Vue.config.productionTip = false;
Vue.use(ElementUI);
// websocket
Vue.prototype.$WS = WS;
// 路由跳转
Vue.prototype.$goRoute = function(index) {
  this.$router.push(index);
};

// 添加一个请求拦截器
axios.interceptors.request.use(
  function(config) {
    // console.log('axios.interceptors.request')
    config.withCredentials = true;
    return config;
  },
  function(err) {
    return Promise.reject(err);
  }
);
// 添加一个响应拦截器
axios.interceptors.response.use(
  function(res) {
    // console.log('axios.interceptors.response')
    if (res.data.errcode === 3001) {
      router.replace("/");
    } else if (res.status === 500) {
    }
    return res;
  },
  function(err) {
    return Promise.reject(err);
  }
);

// 路由拦截器
router.beforeEach((to, from, next) => {
  // if ((to.path === '/' || to.path === '/login')) {    //如果已经登陆过，重定向到主页
  //   axios.get('/api/member/login/ping').then((res)=>{
  //     if (res.data.code === 'OK') {
  //       next('/main/homepage')
  //     } else {
  //       next();
  //     }
  //   });
  //   return;
  // }
  next();
});

let vue = new Vue({
  el: "#app",
  store,
  router,
  render: h => h(App)
});
Vue.use({ vue });
